import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow, } from '@cargomatic/ui';
import Pagination from 'components/v2/PaginationV2';
const ROWS_PER_PAGE = 10;
const EventList = ({ rows, columns }) => {
    const { t } = useTranslation();
    const [page, setPage] = useState(1);
    useEffect(() => {
        setPage(1);
    }, [rows]);
    const totalPages = Math.ceil(rows.length / ROWS_PER_PAGE);
    const displayRows = rows.slice((page - 1) * ROWS_PER_PAGE, page * ROWS_PER_PAGE);
    const localizedColumns = columns.map((col) => (Object.assign(Object.assign({}, col), { text: t(col.text).toUpperCase() })));
    if (!rows.length) {
        return (React.createElement("p", { className: "text-sm text-muted-foreground py-4" }, t('NO_DATA_FOUND')));
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "overflow-x-auto" },
            React.createElement(Table, null,
                React.createElement(TableHeader, null,
                    React.createElement(TableRow, null, localizedColumns.map((col) => (React.createElement(TableHead, { key: col.dataField, className: "whitespace-nowrap" }, col.text))))),
                React.createElement(TableBody, null, displayRows.map((row, rowIndex) => (React.createElement(TableRow, { key: row._id || rowIndex }, localizedColumns.map((col) => (React.createElement(TableCell, { key: col.dataField, className: "whitespace-nowrap" }, col.formatter
                    ? col.formatter(row[col.dataField], row)
                    : row[col.dataField] || ''))))))))),
        totalPages > 1 && (React.createElement(Pagination, { perPage: ROWS_PER_PAGE, page: page, total: rows.length, onPageClick: (p) => setPage(p), showCount: false }))));
};
export default EventList;
